
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Kurlatopunetaxiservice() {



    const cardData =
    {
        keyword: ' Kurla to Pune Taxi Service',
        heading: 'Skyline Cabs: Kurla to Pune Taxi Service ',
        headingDescription: 'Skyline Cabs offers reliable and convenient Kurla to Pune Taxi Service for a smooth intercity travel experience. Whether you are traveling for work, family visits, or a quick getaway, our fleet of well-maintained vehicles and experienced drivers ensures a safe and comfortable journey. With prompt pickups from Kurla, clear pricing, and 24/7 customer support, Skyline Cabs guarantees hassle-free travel. Book your Kurla to Pune taxi today and enjoy a stress-free ride with complete peace of mind.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Kurla to Pune Taxi Service Rates",
    "description": "Skyline Cabs offers highly competitive and transparent taxi service rates for trips from Kurla to Pune. Our pricing is designed to fit a variety of budgets, and we ensure there are no hidden fees. Whether you're traveling for business or leisure, you can expect a comfortable ride with professional drivers and well-maintained vehicles. Our easy online booking system makes it even more convenient for you."
  },
  {
    "name": "Kurla to Pune Taxi Service Number",
    "description": "To book a taxi from Kurla to Pune, simply call Skyline Cabs at [Insert contact number]. Our team is always available to assist you with booking, ensuring you receive timely service. We guarantee that your journey will be safe, comfortable, and affordable, with a choice of various vehicles to suit your travel needs. Book your ride now for a hassle-free trip!"
  },
  {
    "name": "Kurla to Pune One Way Cab Service",
    "description": "Skyline Cabs offers an affordable and reliable one-way cab service from Kurla to Pune. Whether you're traveling for a meeting, a family visit, or any other reason, our one-way service provides a cost-effective solution. Choose from a variety of vehicles such as sedans, SUVs, and luxury options. Our professional drivers ensure a smooth and comfortable ride with a focus on punctuality."
  },
  {
    "name": "Kurla to Pimpri Cab Service",
    "description": "Travel from Kurla to Pimpri with ease and comfort by booking a taxi with Skyline Cabs. We offer a wide range of vehicles to cater to your needs, from budget-friendly options to more luxurious rides. Our services are reliable, punctual, and affordable, ensuring that your trip to Pimpri is smooth and enjoyable. Whether you're traveling alone or in a group, we’ve got you covered."
  },
  {
    "name": "Kurla to Pune Station Cab Fare",
    "description": "Skyline Cabs provides competitive taxi fares for trips from Kurla to Pune Station. With a focus on transparency, our pricing includes all tolls, taxes, and other charges upfront. We offer various vehicle options to suit your preferences and budget. Whether you’re catching a train or visiting a loved one, our drivers will ensure you reach your destination comfortably and on time."
  },
  {
    "name": "Kurla to Baner Cab Fare",
    "description": "Book a taxi from Kurla to Baner, Pune with Skyline Cabs and experience comfort and affordability. We offer competitive fares that make your journey budget-friendly without compromising on quality. With a wide range of vehicles, you can choose the perfect ride that suits your travel preferences. Our skilled drivers are committed to providing a safe, reliable, and timely service."
  },
  {
    "name": "Kurla to Pune Ertiga Cab Fare",
    "description": "If you're looking for an affordable yet comfortable ride from Kurla to Pune, Skyline Cabs offers Ertiga taxi services at great fares. With ample space for families or small groups, the Ertiga is an ideal choice for a smooth and enjoyable trip. Our drivers are courteous and experienced, ensuring that you have a safe and pleasant journey every time."
  },
  {
    "name": "Kurla Station to Pune Taxi Service",
    "description": "Skyline Cabs provides reliable taxi services from Kurla Station to Pune, designed to give you a hassle-free experience. Whether you need a taxi for a quick trip or a more leisurely journey, we have a fleet of well-maintained vehicles that will ensure you travel in comfort. Our professional drivers will ensure that your ride is safe, punctual, and pleasant."
  },
  {
    "name": "Kurla Station to Pune Sedan Taxi Service",
    "description": "Travel from Kurla Station to Pune in comfort and style with Skyline Cabs’ sedan taxi service. Our sedans are well-maintained, spacious, and ideal for both solo travelers and small groups. With a focus on providing the best customer experience, we ensure timely pickups and drop-offs, so you can relax and enjoy your ride without any worries."
  },
  {
    "name": "Kurla to Viman Nagar Taxi",
    "description": "Booking a taxi from Kurla to Viman Nagar has never been easier with Skyline Cabs. Whether you're traveling for business or leisure, our fleet of taxis, including comfortable sedans and spacious SUVs, ensures a smooth ride. We offer competitive fares and prioritize your safety and comfort throughout the journey. Our easy online booking system makes planning your trip stress-free."
  },
  {
    "name": "Kurla to Pune Round Trip Cab",
    "description": "Skyline Cabs offers convenient and cost-effective round trip cab services from Kurla to Pune. This service is perfect for individuals or groups who need a reliable way to travel both ways, ensuring flexibility and comfort throughout the journey. With a variety of vehicles to choose from, you can pick the one that best suits your preferences. Our professional drivers ensure you have a smooth, stress-free round trip."
  },
  {
    "name": "Taxi Service in Kurla Mumbai",
    "description": "Skyline Cabs provides dependable and affordable taxi services within Kurla, Mumbai. Whether you need a ride for a short local trip or a longer outstation journey, our fleet of vehicles is ready to serve you. We offer easy online booking, professional drivers, and a commitment to punctuality and comfort. Book your ride today and enjoy a seamless travel experience."
  },
  {
    "name": "Best Cab Service in Kurla Mumbai",
    "description": "Skyline Cabs is known for providing the best cab services in Kurla, Mumbai. We prioritize customer satisfaction by offering reliable, comfortable, and affordable rides. Whether you're traveling locally or to an outstation destination, our well-maintained vehicles and experienced drivers ensure you enjoy every part of your journey. Choose Skyline Cabs for your next trip and experience the difference."
  },
  {
    "name": "Innova Crysta on Rent in Kurla Mumbai",
    "description": "Skyline Cabs offers premium Innova Crysta rentals in Kurla, Mumbai. Ideal for families, business trips, or small group travel, the Innova Crysta provides both luxury and space. Enjoy the comfort of this well-maintained vehicle with an experienced driver, ensuring a safe and comfortable trip. Whether you're going for a local ride or an outstation journey, we provide competitive rates and top-tier service."
  },
  {
    "name": "Ertiga Hire in Kurla Mumbai",
    "description": "Skyline Cabs offers Ertiga hire services in Kurla, Mumbai, giving you a spacious and comfortable ride for your travels. Perfect for small groups or families, the Ertiga offers ample space and is ideal for both local and outstation trips. With Skyline Cabs, you can enjoy a safe and relaxing journey at affordable prices. Book your Ertiga now for a seamless travel experience."
  }
],
"tableData": [
  ["Kurla to Pune Taxi Service Rates", "Kurla to Pune Taxi Service Number"],
  ["Kurla to Pune One Way Cab Service", "Kurla to Pimpri Cab Service"],
  ["Kurla to Pune Station Cab Fare", "Kurla to Baner Cab Fare"],
  ["Kurla to Pune Ertiga Cab Fare", "Kurla Station to Pune Taxi Service"],
  ["Kurla Station to Pune Sedan Taxi Service", "Kurla to Viman Nagar Taxi"],
  ["Kurla to Pune Round Trip Cab", "Taxi Service in Kurla Mumbai"],
  ["Best Cab Service in Kurla Mumbai", "Innova Crysta on Rent in Kurla Mumbai"],
  ["Ertiga Hire in Kurla Mumbai", ""]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Kurla to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and punctual taxi services from Kurla to Pune, ensuring you arrive on time every time. Whether it’s a business trip, weekend getaway, or family visit, our service ensures a smooth and timely ride."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained vehicles that guarantee a comfortable journey. Whether you're traveling solo or with a group, our air-conditioned sedans, SUVs, and luxury cars provide a relaxed and enjoyable ride from Kurla to Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Skyline Cabs employs experienced, professional drivers familiar with the best routes from Kurla to Pune. They ensure your safety, comfort, and punctuality, providing a stress-free and pleasant journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you always know the cost upfront. Our transparent pricing model has no hidden charges, so you can trust that you’re getting a fair price for your trip from Kurla to Pune, without compromising on service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs operates 24/7, allowing you to book a ride from Kurla to Pune at any time, day or night. Whether it's a last-minute trip or a planned journey, we are always ready to assist you."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your cab is simple and quick with Skyline Cabs. Use our website or mobile app to book a ride in just a few clicks, and get instant booking confirmation with the ability to track your ride in real-time."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "We prioritize your health and safety. All of our vehicles are sanitized thoroughly before every ride, and our drivers follow strict safety protocols, ensuring you travel in a clean, safe, and hygienic environment."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Whether you're traveling alone, with family, or in a group, Skyline Cabs offers a variety of vehicles to suit your needs. From comfortable sedans for solo travelers to spacious SUVs for groups, we have you covered for your journey from Kurla to Pune."
    }
]


















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Kurla to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Kurla to Pune is simple and quick. You can book through our website, mobile app, or by calling our customer support team. Just enter your pickup and drop-off details, select your preferred vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Kurla to Pune trip?',
            answer:
                'We offer a variety of vehicles to suit your preferences, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the vehicle based on the number of passengers and your comfort requirements.',
        },
        {
            id: 3,
            question: 'How long will it take to travel from Kurla to Pune?',
            answer:
                'The travel time from Kurla to Pune typically ranges from 3.5 to 5 hours, depending on traffic conditions. Our professional drivers take the best routes to ensure you have a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares for the Kurla to Pune cab fixed?',
            answer:
                'Yes, our fares are fixed, and we provide upfront pricing, including tolls, taxes, and driver fees. You’ll know the total cost before confirming your booking, ensuring complete transparency.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab service from Kurla to Pune?',
            answer:
                'Yes, you can easily book a round-trip cab. Simply provide your return trip details while booking, and we’ll take care of the rest, ensuring a comfortable return journey as well.',
        },
        {
            id: 6,
            question: 'Can I make modifications to my Kurla to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking via our website, app, or by contacting our customer support team. We offer flexible options to accommodate changes and cancellations.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Kurla to Pune well-maintained?',
            answer:
                'Absolutely! We ensure that all our vehicles are regularly maintained and thoroughly cleaned. We prioritize comfort and safety, ensuring you have a pleasant and worry-free ride.',
        },
        {
            id: 8,
            question: 'What payment options are available for my Kurla to Pune cab?',
            answer:
                'We offer secure online payment options such as credit/debit cards, UPI, and net banking. Alternatively, you can choose to pay in cash at the end of your ride.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs available for corporate travel from Kurla to Pune?',
            answer:
                'Yes, Skyline Cabs offers corporate travel services, providing reliable and comfortable transport for business meetings, conferences, or group travel. Contact us for tailored services that meet your corporate needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Kurla to Pune journey?',
            answer:
                'Skyline Cabs is known for its professional drivers, well-maintained vehicles, affordable pricing, and excellent customer service. We prioritize comfort, safety, and timely arrivals, ensuring you have a smooth, hassle-free journey from Kurla to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I traveled from Kurla to Pune for a weekend trip, and Skyline Cabs made it a comfortable experience. The car was clean and well-maintained, and the driver was polite and professional. I’ll definitely book again!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Had a good experience with Skyline Cabs for my Kurla to Pune journey. The ride was smooth, and the driver was punctual. It would’ve been perfect if the AC was a little cooler, but overall, I’m satisfied with the service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kurla to Pune Taxi",
  "image": "https://skylinecabs.com/assets/images/kurla-to-pune-taxi.jpg",
  "description": "Book Kurla to Pune taxi with Skyline Cabs for a comfortable and affordable journey. AC sedan and SUV cabs available 24/7 for one-way and round-trip rides with professional, verified drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7026"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/kurla-to-pune-taxi"
  }
};


      
     


    return (
        <div>
 
<Helmet>
  <title>Kurla to Pune Taxi | 24/7 AC Cab Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Kurla to Pune taxi with Skyline Cabs for a comfortable and affordable journey. AC sedan and SUV cabs available 24/7 for one-way and round-trip rides with professional, verified drivers." 
  />
  <meta 
    name="keywords" 
    content="Kurla to Pune Taxi, Cab from Kurla to Pune, One-Way Taxi Kurla to Pune, Round Trip Cab Kurla to Pune, AC Cab Kurla to Pune, SUV Taxi Kurla to Pune, Affordable Taxi Kurla to Pune, Skyline Cabs Kurla to Pune, Online Taxi Booking Kurla to Pune, 24/7 Cab Service Kurla to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/48.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kurlatopunetaxiservice;